var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.trade_detail_form.flag)?_c('TradeDetailForm',{attrs:{"is_user_content":_vm.is_user,"trade_detail_form":_vm.trade_detail_form}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }